import { createFileRoute } from "@tanstack/react-router";

import { ComparisonHubPage } from "@/components/marketing/comparison-page";
import { alternativesHubHead } from "@/lib/seo";

/** The comparisons come from the loader, for the reason in `$competitor`. */
export const Route = createFileRoute("/(public)/alternatives/")({
  loader: async () => {
    const { COMPARISON_LIST } = await import(
      "@/components/marketing/comparison-data"
    );
    return { comparisons: COMPARISON_LIST };
  },
  head: ({ loaderData }) =>
    loaderData ? alternativesHubHead(loaderData.comparisons) : {},
  component: AlternativesHubRoute,
});

function AlternativesHubRoute() {
  const { comparisons } = Route.useLoaderData();
  return <ComparisonHubPage comparisons={comparisons} />;
}
